import { createAction, props, union } from '@ngrx/store';
import { Student } from '../../model/student.model';

export enum UserActionTypes {
    GET_USER = '[User] Get User',
    GET_USER_SUCCESS = '[User] Get User Success',
    GET_USER_FAILURE = '[User] Get User Failure',
    RESET_PASSWORD = '[User] Reset Password',
    RESET_PASSWORD_SUCCESS = '[User] Reset Password Success',
    RESET_PASSWORD_FAILURE = '[User] Reset Password Failure',
    RESET_PASSWORD_CONFIRM = '[User] Reset Password Confirm',
    RESET_PASSWORD_CONFIRM_SUCCESS = '[User] Reset Password Confirm Success',
    RESET_PASSWORD_CONFIRM_FAILURE = '[User] Reset Password Confirm Failure',
    CLEAR_MESSAGE = '[User] Clear Message',  
}

export const GetUser = createAction(
    UserActionTypes.GET_USER,
)

export const GetUserSuccess = createAction(
    UserActionTypes.GET_USER_SUCCESS,
    (user) => ({ user })
)

export const GetUserFailure = createAction(
    UserActionTypes.GET_USER_FAILURE,
)

export const ResetPassword = createAction(
    UserActionTypes.RESET_PASSWORD,
    props<{ email: string }>()
)

export const ResetPasswordSuccess = createAction(
    UserActionTypes.RESET_PASSWORD_SUCCESS,
    props<{ message: string }>()
)

export const ResetPasswordFailure = createAction(
    UserActionTypes.RESET_PASSWORD_FAILURE,
    props<{ message: string }>()
)

export const ResetPasswordConfirm = createAction(
    UserActionTypes.RESET_PASSWORD_CONFIRM,
    props<{ uid: string, token: string, password: string }>()
)

export const ResetPasswordConfirmSuccess = createAction(
    UserActionTypes.RESET_PASSWORD_CONFIRM_SUCCESS,
    props<{ message: string }>()
)

export const ResetPasswordConfirmFailure = createAction(
    UserActionTypes.RESET_PASSWORD_CONFIRM_FAILURE,
    props<{ message: string }>()
)

export const ClearMessage = createAction(
    UserActionTypes.CLEAR_MESSAGE,
)

const actions = union({
    GetUser,
    GetUserSuccess,
    GetUserFailure,
    ClearMessage,
    ResetPasswordConfirm,
    ResetPasswordConfirmSuccess,
    ResetPasswordConfirmFailure,
    ResetPassword,
    ResetPasswordFailure,
    ResetPasswordSuccess
});
  
export type UserActionsUnions = typeof actions;